import { FiChevronLeft, FiFileText } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router';
import { DataTable, StyledButton } from '../../../../components';
import { Loading } from '../../../../components/Loading';
import { useDetalheExtrato } from '../../../../services/hooks/useDetalheExtrato';
import { AdminTitle } from '../../components';
import { ContaContainer, FiltersContainer, Row } from './styles';
import Moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useUserDocument } from '../../../../services/contexts/UserDocumentContext';

const tableHead = [
  'Descrição do produto',
  'Série',
  'Número da Ordem',
  'Parcela',
  'Valor Baixa',
  'Valor Bruto',
  'Data Emissão',
  'Data Prev. Pagamento',
  'Data Baixa',
];

const tableTransaction = [
  'ID',
  'Origem',
  'Data Movimento',
  'Valor Movimento',
  'Código do Movimento',
  'ID Conta Estabelecimento',
];

export const DetalheExtrato = () => {
  const { documentSelected } = useUserDocument();
  const docto = useMemo(() => documentSelected as string, [documentSelected]);

  const paramsByLink = useParams();
  const navigate = useNavigate();

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const id = paramsByLink.id ?? '';

  const [params, setParams] = useState({
    docto: '',
    id: '',
    pagina: page,
    limite: itemsPerPage,
  });

  const { data, isLoading, isFetching, error, refetch } = useDetalheExtrato({
    ...params,
    pagina: page,
    limite: itemsPerPage,
  });

  useEffect(() => {
    const newParams = {
      docto: docto,
      id: id,
      pagina: page,
      limite: itemsPerPage,
    };

    setParams(newParams);
    refetch();
  }, [docto, id, page, itemsPerPage, refetch]);

  return (
    <ContaContainer>
      <AdminTitle title="Detalhes da transação" icon={<FiFileText />} />

      <FiltersContainer>
        <StyledButton
          text="Voltar"
          icon={<FiChevronLeft color="#005FAE" />}
          iconPosition="left"
          iconBorderRadius
          iconWhiteBackground
          color="#005FAE"
          onClick={() => navigate(`/admin/extrato`)}
        />
      </FiltersContainer>

      <DataTable
        title="Resumo da Transação"
        heads={tableTransaction}
        hasPagination={false}
      >
        {isLoading || isFetching ? (
          <Loading />
        ) : error ? (
          <Row>
            <td colSpan={11}>Falha ao obter dados</td>
          </Row>
        ) : data?.detalhe == null || data.detalhe.length === 0 ? (
          <Row>
            <td colSpan={11}>Não foram encontrados dados.</td>
          </Row>
        ) : (
          <Row>
            <td>{data?.transacao?.id}</td>
            <td>{data?.transacao?.origem}</td>
            <td>
              {data?.transacao?.dtMovimento
                ? new Date(data?.transacao?.dtMovimento)?.toLocaleDateString(
                    'pt-BR'
                  )
                : ''}
            </td>

            <td>
              {data?.transacao?.vlMovimento
                ? new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  }).format(data?.transacao?.vlMovimento)
                : ''}
            </td>
            <td>{data?.transacao?.codMovimento.toString()}</td>
            <td>{data?.transacao?.idContaEstabelecimento}</td>
          </Row>
        )}
      </DataTable>

      <DataTable
        title="Transações Detalhadas"
        heads={tableHead}
        hasPagination
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        page={page}
        setPage={setPage}
        totalItems={data?.total}
      >
        <tbody>
          {isLoading || isFetching ? (
            <Loading />
          ) : error ? (
            <Row>
              <td colSpan={11}>Falha ao obter dados</td>
            </Row>
          ) : data?.detalhe == null || data.detalhe.length === 0 ? (
            <Row>
              <td colSpan={11}>Não foram encontrados dados.</td>
            </Row>
          ) : (
            data?.detalhe?.map((data, i) => (
              <Row key={i}>
                <td>{data.produtoDescricao}</td>
                <td>{data.serie}</td>
                <td>{data.numOrdem}</td>
                <td>{data.parcela}</td>
                <td>
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  }).format(data.vlBaixa)}
                </td>
                <td>
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  }).format(data.vlBruto)}
                </td>
                <td>
                  {data.dtEmissao
                    ? Moment(data.dtEmissao).format('DD/MM/yyyy')
                    : ''}
                </td>
                <td>
                  {data.dtPrevPgto
                    ? Moment(data.dtPrevPgto).format('DD/MM/yyyy')
                    : ''}
                </td>
                <td>
                  {data.dtBaixa
                    ? Moment(data.dtBaixa).format('DD/MM/yyyy')
                    : '-'}
                </td>
              </Row>
            ))
          )}
        </tbody>
      </DataTable>
    </ContaContainer>
  );
};
